/**
 * Check Version Support
 *
 * Checks version strings and returns true if
 * version is greater than or equal to supported.
 *
 * @param {string} currentVersion Current version string.
 * @param {string} supportedVersion Supported version string.
 * @return {boolean}
 */
const checkVersionSupport = (currentVersion, supportedVersion, index = 0) => {
	const current = String(currentVersion || 0);
	const supported = String(supportedVersion || 0);

	// Test valid version strings
	if (!currentVersion || /[^0-9.]+/.test(current)) {
		console.error('Version check: invalid current version', current);
		return false;
	}

	if (!supportedVersion || /[^0-9.]+/.test(supported)) {
		console.error('Version check: invalid supported version', supported);
		return false;
	}

	const limit = Math.max(current.split('.').length, supported.split('.').length);
	const currVal = parseInt(current.split('.')[index] || 0, 10);
	const suppVal = parseInt(supported.split('.')[index] || 0, 10);

	// Version Index Supported
	if (currVal > suppVal) {
		return true;
	}
	// Version Index Not supported
	if (currVal < suppVal) {
		return false;
	}
	// Version Index Equal, test next index
	if ((index + 1) < limit) {
		return checkVersionSupport(current, supported, (index + 1));
	}
	// Version Index Equal, limit hit, versions match
	return true;
}

export default checkVersionSupport;